import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useReactFlow } from "reactflow";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { RootState } from "../../redux/store";
import { addUpdateNodeToQueue, handleWorkflowRun, handleWorkflowSave } from "../../services/method";
import { LoopProject } from "./loop";
import { ExportProject } from "./export";
import { ChatProject } from "./chat";
import { APIProject } from "./API";
// import { reduxUpdateError } from "../../redux/reducers/error";
import { Main } from "./style";
// import { cancelAllRequests, webURL } from "../../services/API";
// import axios from "axios";
// import { reduxUpdateSettings } from "../../redux/reducers/settings";
import { operationType } from "../../services/types";
// import { reduxUpdatePrevUser } from "../../redux/reducers/user";
import { TextInput } from "../form/textInput";
import { Play, RotateCcw, Save, RotateCcwSquare, SquareArrowOutUpRight, Repeat, X, AlertTriangle } from "lucide-react";
import socket from "../../services/socket";
import { reduxUpdateSettings } from "../../redux/reducers/settings";

let intervalId: any = 0;

export function RunActions({ project, setProject }: { project: projectType | null, setProject: React.Dispatch<React.SetStateAction<projectType | null>> }) {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const userToken = useSelector((state: RootState) => state.user.data?.token);
   const isWorkflowRun = useSelector((state: RootState) => state.settings.data.isWorkflowRun);
   const [state, setState] = React.useState({ isRun: false, isLoop: false, isExport: false, isChat: false, isAPI: false, isReset: false, isRunRealTime: false });
   const [setupChat, setSetupChat] = React.useState({ 
      inputId: '', outputId: '', start: false, isInputHover: false, isOutputHover: false, 
      isNodesUpdated: false, isCanGetOutput: false
   });
   const [tabsChat, setTabsChat] = React.useState<tabChatType[]>([]);
   const [resetValue, setResetValue] = React.useState('');
   const [searchParams] = useSearchParams();
   const isExternalChat = React.useMemo(() => searchParams.get('isExternalChat') === 'true', [searchParams]);
   const { getNodes, getEdges, setNodes, setEdges } = useReactFlow();

   // Real-Time
   React.useEffect(() => {
      const handleWebhook = (data: any) => { 
         const projectId = searchParams.get('id');
         if (projectId !== data.projectId) return;
         setState(state => ({ ...state, isRunRealTime: !data.isDone }));
         dispatch(reduxUpdateSettings({ isWorkflowRun: !data.isDone }));

         if (data.isFirst) {
            addUpdateNodeToQueue(setNodes, (nodes) => nodes.map((node) => {
               if (node.data.action === 'output') return { ...node, data: { ...node.data, value: '' }};
               else return node;
            }));
         }
         const nodes = getNodes();
         const index = Object.keys(data)[0];
         const item = nodes.find(node => node.data.index === index);
         const sources: operationType[] = [];

         for (const edge of getEdges()) {
            if (edge.source === item?.id) {
               for (const node of nodes) {
                  if (node.id === edge.target && node.data.action === 'output') {
                     sources.push({ id: node.id, sourceHandle: edge.sourceHandle, ...node.data });
                  }
               }
            }
         }
         // with webhook only
         let webhookExtractorsData: { [key: string]: any } | null = null;

         if (item?.data.action === 'webhook') {
            const mainKey = Object.keys(data[index])[0];
            webhookExtractorsData = { [mainKey]: data[index][mainKey] }

            for (let num in data[index].extractorsData) { // @ts-ignore
               num = parseInt(num);
               webhookExtractorsData[`Extractor-${num+1}`] = data[index].extractorsData[num];
            }
         }

         console.log(data);
         console.log(webhookExtractorsData);

         addUpdateNodeToQueue(setNodes, (nodes) => (nodes).map((node) => {
            const find = sources.find(source => source.id === node.id && node.data.action === 'output');
            const findFromEnd = data.nodes?.find((n: any) => n.id === node.id);
            
            if (find) {
               const final = webhookExtractorsData || data[index]?.Output || data[index];
               return { ...node, data: { ...node.data, 
                  value: ['string', 'number', 'boolean'].includes(typeof final) ? final
                  : Array.isArray(final) || (typeof final === 'object' && !Object.keys(final)[0]?.includes('Output')) ? JSON.stringify(final, null, 2)
                  : final[find.sourceHandle as string]
               }}
            } else if (findFromEnd && node.data.outputType) {
               return { ...node, data: { ...node.data, value: { ...findFromEnd.data.value, isTemporaryMemory: false }}};
            } else if (node.data.index === index) {
               return { ...node, data: { ...node.data, value: { ...node.data.value, ...(data[index]?.updateNodeValue || {}), isTemporaryMemory: false }}};
            } else if (node.data.outputType) {
               return { ...node, data: { ...node.data, value: { ...node.data.value, isTemporaryMemory: false }}};
            } else return node;
         }));
         addUpdateNodeToQueue(setNodes, (nodes) => (nodes).map((node) => {
            if (node.data.index === index) {
               return { ...node, data: { ...node.data, output: data[index] }};
            } else return node;
         }));
      }
      socket.off('runMonitoringInClient');
      socket.on('runMonitoringInClient', handleWebhook);
      return () => { socket.off('runMonitoringInClient', handleWebhook) }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // loop run
   React.useEffect(() => {
      if (project?.loop.starting && project.loop.value) {
         intervalId = setInterval(handleWorkflowRunGlobal, project.loop.value * 60 * 1000);
      }
      return () => clearInterval(intervalId);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [project?.loop.starting]);

   // ---
   const handleWorkflowRunGlobal = async () => {
      const workflowId = searchParams.get('id') as string;
      await handleWorkflowRun(
         workflowId, 
         userToken as string, 
         getNodes(), 
         getEdges(), 
         state.isRunRealTime, 
         state.isRun, 
         project?.apiKey as string,
         dispatch,
         navigate,
         setNodes,
         handleValuesFeatures
      );
      handleWorkflowSave(workflowId, userToken as string, getNodes(), getEdges())
   }
   // ---
   const handleValuesFeatures = (values: any) => setState(state => ({ ...state, ...values }));

   return (
      <Main>
         <ul>
            <li id="running" className={ state.isRun ? 'running' : state.isRunRealTime ? 'running disabled' : '' } onClick={ handleWorkflowRunGlobal }>
               { state.isRun || state.isRunRealTime ? <AiOutlineLoading3Quarters /> : <Play size="16px" /> }
               { state.isRunRealTime ? <span>Live</span>  : (state.isRun ? <span>Stop</span> : <span>Run</span>) }
            </li>
            <li className={ project?.loop.starting ? 'loop' : '' } onClick={ _=> setState(state => ({ ...state, isLoop: true })) }>
               { project?.loop.starting ? <Repeat size="16px" /> : <RotateCcw size="16px" /> }
               <span>Loop</span>
            </li>
            <li onClick={ _=> { if (!isWorkflowRun) handleWorkflowSave(searchParams.get('id') as string, userToken as string, getNodes(), getEdges())} }>
               <Save size="16px" />
               <span>Save</span>
            </li>
            <li onClick={ _=> setState(state => ({ ...state, isReset: true }))}>
               <RotateCcwSquare size="16px" />
               <span>Reset</span>
            </li>
            <li onClick={ _=> setState(state => ({ ...state, isExport: true })) }>
               <SquareArrowOutUpRight size="16px" />
               <span>Export</span>
            </li>
         </ul>
         { 
            state.isLoop && project?.loop ? <LoopProject project={ project } setProject={ setProject } handleClose={ () => handleValuesFeatures({ isLoop: false }) } /> :
            state.isExport ? <ExportProject handleValuesFeatures={ handleValuesFeatures } /> : 
            state.isChat || isExternalChat ? <ChatProject projectId={ project?._id } setup={ setupChat } setSetup={ setSetupChat } tabsChat={ tabsChat } setTabsChat={ setTabsChat } handleWorkflowRun={ handleWorkflowRunGlobal } handleValuesFeatures={ handleValuesFeatures } /> :
            state.isAPI ? <APIProject data={ project } handleValuesFeatures={ handleValuesFeatures } /> : null
         }
         { state.isReset ? <div className="popup reset" onClick={ _=> setState(state => ({ ...state, isReset: false }))}>
            <div onClick={ e => e.stopPropagation() }>
               <div className="close" onClick={ _=> setState(state => ({ ...state, isReset: false }))}>
                  <X size={ 19 } />
               </div>
               <div className="content">
                  <div className="title">
                     <div className="icon"><AlertTriangle size={ 20 } /></div>
                     <h3>Reset ({ project?.name })</h3>
                  </div>
                  <div className="info">
                     <div>
                        <span>Are you sure you want to reset the project?</span>
                        <span>This action will permanently delete all workflow data, connections, and configurations. This cannot be undone.</span>
                     </div>
                     <label>Type “{ project?.name }” below to confirm:</label>
                     <TextInput placeholder={`Enter '${project?.name}' to confirm`} value={ resetValue } isNormal handleChange={ e => setResetValue(e.target.value) } />
                  </div>
                  <div className="tip">
                     <span><AlertTriangle size={ 18 } /></span>
                     <span><span>Warning:</span> This will remove all nodes, connections, and saved workflow configurations. Make sure you have exported any important workflows before proceeding.</span>
                  </div>
                  <div className="action">
                     <button onClick={ _=> setState(state => ({ ...state, isReset: false }))} className="cancel">Cancel</button>
                     <button 
                        onClick={ _=> { 
                           setNodes([]); setEdges([]); 
                           setState(state => ({ ...state, isReset: false }));
                           setResetValue('');
                        }}
                        disabled={ resetValue !== project?.name }
                     >Reset Project</button>
                  </div>
               </div>
            </div>
         </div> : null }
      </Main>
   );
}